import React from 'react'
import classNames from 'classnames'
import { LinkButton } from '@/atoms/Button'
import { ArtIcon } from '@/atoms/Icons/ArtIcon'
import { GuildIcon } from '@/atoms/Icons/GuildIcon'
import { HeartIcon } from '@/atoms/Icons/HeartIcon'
import { SceneIcon } from '@/atoms/Icons/SceneIcon'
import { SignatureIcon } from '@/atoms/Icons/SignatureIcon'
import { Image } from '@/atoms/Image'
import { PaddedContainer } from '@/atoms/PaddedContainer'
import { HeadingXL, HeadingXS, ParagraphMD, ParagraphXL, TitleMD } from '@/atoms/Text'
import { ANGEL_STUDIOS_EMAIL_GROUP_ID } from '@/constants/email'
import { paths } from '@/constants/paths'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'
import { useTranslate } from '@/utils/translate/translate-client'
import { EmailCaptureSignupModal } from '../../WatchTheatricalView/GetInvolvedSquare/EmailCaptureSignupModal'

export const CollectiblesViewWingfeather = () => {
  const { t } = useTranslate('collectibles')
  const [showEmailCapture, setShowEmailCapture] = React.useState(false)
  const { query } = useSafeRouter()
  const projectId = query.projectId as string

  const handleShowEmailCapture = () => {
    setShowEmailCapture(!showEmailCapture)
  }

  return (
    <div className="bg-core-gray-100">
      {showEmailCapture && (
        <EmailCaptureSignupModal
          isOpen={true}
          onClose={handleShowEmailCapture}
          filmName="The Wingfeather Saga"
          projectSlug="wingfeather-saga"
          emailListId={ANGEL_STUDIOS_EMAIL_GROUP_ID}
          headline="Be the first to know when The Wingfeather Saga Collectibles Launch"
          bodyText=" "
        />
      )}
      <header className="flex flex-col items-center py-12 text-center md:pt-10">
        <HeadingXL className="md:photon-display my-6" weight="bold">
          Angel Collectibles
        </HeadingXL>
        <ParagraphXL className="max-w-2xl text-pretty px-10 text-center">
          Own a Collectible Frame of your favorite shows and movies from Angel Studios and help support future shows.
        </ParagraphXL>
        <div className="mx-auto my-6 flex w-fit flex-wrap items-center justify-center gap-6">
          <img
            src="https://images.angelstudios.com/image/upload/v1713913136/collectibles/dedicate-your-scene-patrick-family.jpg"
            alt="A digital frame of a show"
            // width={750}
            // height={400}
            className="mx-auto block"
          />
        </div>
      </header>
      <section className="flex flex-col items-center bg-core-gray-200 py-10 text-center">
        <HeadingXL color="core-gray-900" weight="bold">
          {t('saveTheShow', 'Save the Show')}
        </HeadingXL>
        <ParagraphXL className="my-2 max-w-2xl text-pretty px-10 text-center">
          {t(
            'collectiblesForTheWingfeatherSagaAvailableNowV1',
            'Collectibles for The Wingfeather Saga are available now. You can buy for yourself or gift to a loved one.',
          )}
        </ParagraphXL>
        <LinkButton href={paths.collectibles.shop(projectId)} variant="oxide-primary" className="mx-auto my-6 p-8">
          <HeadingXS weight="bold">{t('fundSeasonThreeV1', 'Fund Season 3')}</HeadingXS>
        </LinkButton>
      </section>
      {/* <section className="bg-core-gray-100 py-12">
        <PaddedContainer>
          <HeadingXL className="md:photon-dispay my-5 text-center" weight="bold">
            The Wingfeather Saga funding Progress
          </HeadingXL>
          <ProjectFundingGoalDisplayV4
            slug="wingfeather-saga"
            loading={false}
            raised="$400,000"
            raisedRaw={800}
            cost="$8,000,000"
            backers="100"
            percentProgress={5}
          />
        </PaddedContainer>
      </section> */}
      <section className="bg-core-gray-100 py-10 md:py-16">
        <PaddedContainer className="flex flex-col items-center">
          <div className="max-w-lg px-5 py-10 md:px-10">
            <ParagraphXL>Every bit makes a difference</ParagraphXL>
            <HeadingXS className="md:photon-heading-sm" weight="bold">
              How you can help
            </HeadingXS>
          </div>
          <div className="flex gap-8">
            <div className="flex w-80 flex-col gap-2 rounded-xl bg-white px-6 py-8 md:w-[436px]">
              <GuildIcon color1="core-gray-700" size={30} />
              <TitleMD weight="bold">Guild Membership</TitleMD>
              <ParagraphMD>Help Angel Studios build a library of shows that amplify light.</ParagraphMD>
              <LinkButton
                href={`${paths.guild.join}?utm_campaign=collectibles-guild&utm_term=wingfeather-saga&utm_source=collectibles&utm_medium=web`}
                variant="black"
                className="w-fit"
                target="_blank"
              >
                Continue
              </LinkButton>
            </div>
            <div className="flex w-80 flex-col gap-2 rounded-xl bg-white px-6 py-8 md:w-[436px]">
              <SceneIcon color1="white" size={30} color2="core-gray-700" />
              <TitleMD weight="bold">Digital Collectible</TitleMD>
              <ParagraphMD>
                Help fund the Wingfeather Saga Season 3 so that the next season can be released.
              </ParagraphMD>
              <LinkButton href={paths.collectibles.shop(projectId)} variant="black" className="w-fit">
                Continue
              </LinkButton>
            </div>
            <div className="flex w-80 flex-col gap-2 rounded-xl bg-white px-6 py-8 md:w-[436px]">
              <ArtIcon color="core-gray-700" size={34} />
              <TitleMD weight="bold">Printable Collectible</TitleMD>
              <ParagraphMD>
                Help fund the Wingfeather Saga Season 3 with a Digital Collectible and framed printed keepsake.
              </ParagraphMD>
              <LinkButton href={paths.collectibles.shop(projectId)} variant="black" className="w-fit">
                Continue
              </LinkButton>
            </div>
          </div>
        </PaddedContainer>
      </section>
      <section className="my-10 flex flex-col items-center bg-core-gray-200">
        <ImageCard
          icon={<HeartIcon color1="core-gray-700" size={23} />}
          image="/f_webp/v1713556892/collectibles/wingfeather-saga/family-gift"
          title="Gift to Loved Ones"
          description="You can share Digital Collectibles with loved ones and dedicate the frame and printable keepsakes with a note."
        />
        <ImageCard
          icon={<SceneIcon color1="white" size={30} color2="core-gray-700" />}
          image="/f_webp/v1712960064/collectibles/wingfeather-saga/wingfeather-player"
          title="View in the Player"
          description="View your Digital Collectible in the Angel Studios web player where you can share with others, view, print, and enjoy it."
          imgRight
        />
        <ImageCard
          icon={<ArtIcon color="core-gray-700" size={34} />}
          image="/f_webp/v1712959643/collectibles/wingfeather-saga/wingfeather-frame"
          title="Print and Display on Your Wall"
          description="Coming soon you’ll be able to print off your Digital Collectible frame with a print service."
        />

        <ImageCard
          icon={<SignatureIcon color="core-gray-700" size={30} />}
          image="/f_webp/v1712960156/collectibles/wingfeather-saga/wingfeather-frame-signed"
          title="Livestream Signatures"
          description="Join exclusive livestreams for the chance to get your Digital Collectible signed by a member of The Wingfeather Saga team."
          imgRight
        />
      </section>
      <section className="my-10 bg-core-gray-200 py-10">
        <HeadingXL className="text-center" weight="bold">
          Explore Scenes Now
        </HeadingXL>
        <LinkButton
          href={paths.collectibles.shop(projectId)}
          variant="oxide-primary"
          className="mx-auto my-6 w-fit p-8"
        >
          <HeadingXS weight="bold">{t('fundSeasonThreeV1', 'Fund Season 3')}</HeadingXS>
        </LinkButton>
      </section>
    </div>
  )
}

interface CardProps {
  icon: React.ReactNode
  title: string
  description: string
}

const Card: React.FC<CardProps> = ({ icon, title, description }) => {
  return (
    <div className="mx-4 w-72 rounded-2xl bg-white p-6 md:w-80">
      <div>{icon}</div>
      <TitleMD weight="bold" color="core-gray-900" className="mb-3 mt-5 text-pretty">
        {title}
      </TitleMD>
      <ParagraphMD>{description}</ParagraphMD>
    </div>
  )
}

const ImageWithAspectRatio = ({
  alt,
  className,
  src,
  width,
  height,
}: {
  alt?: string
  className?: string
  src: string
  width: number
  height: number
}) => (
  <div className={classNames('aspect-h-9 aspect-w-16', className)}>
    <Image src={src} alt={alt} width={width} height={height} className="aspect-content object-contain" />
  </div>
)

interface ImageCardProps extends CardProps {
  image: string
  imgRight?: boolean
}

const ImageCard: React.FC<ImageCardProps> = ({ image, imgRight, ...props }) => {
  return (
    <div
      className={classNames(
        'mx-4 my-10 px-4 md:px-10 flex flex-col items-center rounded-xl bg-white py-10 w-fit md:justify-center lg:px-20 md:gap-x-4 md:mx-auto md:my-16',
        imgRight ? 'md:flex-row-reverse' : ' md:flex-row',
      )}
    >
      <ImageWithAspectRatio className="w-[320px] md:w-[400px]" src={image} alt={props.title} width={320} height={200} />
      <Card {...props} />
    </div>
  )
}
